import $ from 'jquery';
import React from 'react';
import { createPortal } from 'react-dom';
import CategoryAndFolderSelector from './CategoryAndFolderSelector';

import { EVENTS } from '../../utilities/CONSTANTS';

const getInitialCategoryId = () => {
    const categoryId = window._tettraDraft ? window._tettraDraft.category_id : window.draftCategoryId;

    return !isNaN(categoryId) && categoryId;
};

const getInitialFolderId = () => {
    const folderId = window._tettraDraft ? window._tettraDraft.folder_id : window.draftFolderId;
    const categoryId = getInitialCategoryId();

    return categoryId && !isNaN(folderId) && folderId;
};

class MoveDraftModal extends React.Component {
    state = {
        categoryId: getInitialCategoryId(),
        folderId: getInitialFolderId(),
    };

    handleSubmit = () => {
        const { categoryId, folderId } = this.state;
        if (window._tettraDraft) {
            window._tettraDraft.category_id = categoryId;
            window._tettraDraft.folder_id = folderId;
        } else {
            window.draftCategoryId = categoryId;
            window.draftFolderId = folderId;
        }
        window.dispatchEvent(new Event(EVENTS.UPDATED_DRAFT_VALUES));
        return this.props.closeModal();
    };

    handleClick = (e) => {
        const { target } = e;
        if ($(target).hasClass('react-modal')) {
            this.props.closeModal();
        }
    };

    render() {
        const { categoryId, folderId } = this.state;

        return createPortal(
            <div className="react-modal open move-page-modal" onMouseDown={this.handleClick}>
                <div className="modal-content">
                    <h2>Move draft</h2>
                    <div className="mt2 mb2">
                        <CategoryAndFolderSelector
                            initialCategoryId={categoryId}
                            initialFolderId={folderId}
                            setCategoryId={(categoryId) => this.setState({ categoryId })}
                            setFolderId={(folderId) => this.setState({ folderId })}
                        />
                    </div>
                    <div className="right-align">
                        <span className="btn-secondary mr1" onMouseDown={this.props.closeModal}>Close</span>
                        <span className="btn btn-primary move-draft-submit" onMouseDown={this.handleSubmit}>Move draft</span>
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
}

export default MoveDraftModal;
